import './imagetextblock.less'

import {classes, Component} from '@codeurs/front'
import m from 'mithril'
import {ImageType, LinkType, WysiwygType} from 'types/types'
import Container from 'views/layout/container'
import Wysiwyg from 'views/layout/wysiwyg'
import ImageBlock from './imageblock'

export type ImageTextBlockType = {
	mod: 'left' | 'right'
	text: WysiwygType
	image?: ImageType
	image_link?: LinkType
}

export default class ImageTextBlock extends Component<ImageTextBlockType> {
	view() {
		const {text, image, mod, image_link} = this.attrs
		if (!text) return null
		return m('.imagetextblock', {...classes({mod})}, [
			m(Wysiwyg, {html: text}),
			m(ImageBlock, {mod, image, image_link})
		])
	}
}
